import { filter, includes, toLower } from 'lodash';

export const searchResult = (data: any, search: string) => {
  //filter song based on status
  const filterData = filter(data, (item: any) => item.submission_status === 'ACCEPTED');

  const result = filter(filterData, (item: any) => includes(toLower(item.title), toLower(search)));

  return result;
};
